// src/api/shared.js
// No extra "/api" in the base — keep base as ORIGIN only.
// Append the path once, safely.

const join = (base, path) =>
    `${String(base).replace(/\/+$/, '')}/${String(path).replace(/^\/+/, '')}`;

export const getSharedClassification = (shareToken) => {
    // 1) Prefer build-time env (prod: https://sortifi.org/api)
    // 2) Fallbacks: same-origin in prod, localhost in dev
    const API_ORIGIN =
        process.env.REACT_APP_API_URL
        || (window.location.hostname === 'sortifi.org'
            ? window.location.origin          // https://sortifi.org
            : 'http://localhost:8081');       // dev backend

    // Backend path (exactly once)
    const PATH = `/api/shared/classification/${encodeURIComponent(shareToken)}`;

    const url = join(API_ORIGIN, PATH);

    return fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit', // public endpoint
    }).then((res) => {
        if (!res.ok) throw new Error('Shared classification not found');
        return res.json();
    });
};
